import { render, staticRenderFns } from "./collegeClassUpdate.vue?vue&type=template&id=92a5aa72&"
import script from "./collegeClassUpdate.vue?vue&type=script&lang=js&"
export * from "./collegeClassUpdate.vue?vue&type=script&lang=js&"
import style0 from "./collegeClassUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports